var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-info-component',{attrs:{"title":_vm.$t('pages.dashboard.widgets.vacation_forecast'),"value":_vm.holidaysTotal,"is-loading":!_vm.userData,"icon":"fa-calendar-check","tone":"info"}})}
var staticRenderFns = []

export { render, staticRenderFns }